import logoPositive from 'assets/images/logo-home-der.svg'

const Logo = ({ showAlways = false, className = '', imgClassName = '' }) => (
  <div
    className={`${!showAlways && 'hidden'} ${className} md:flex justify-center`}
  >
    <img
      className={`${
        showAlways ? 'w-44' : 'w-full'
      } w-[10.625rem] ${imgClassName}`}
      src={logoPositive}
      alt='Waynimóvil'
    />
  </div>
)

export default Logo
